import Immutable from 'immutable';

const options = {
  mcId: '',
  loading: false,
  spin: false,
  customers: [],
  campaigns: {},
  cycle: [],
  indexedCampaigns: {},
  groupedCampaigns: {},
  namedCampaigns: {},
  groupedAdGroups: {},
  selectedMenu: 'settings',
  selectedLocale: 'English',
  translations: {},
  languages: {
    'English': 'English',
    'Japanese': '日本語',
  },
  keywords: [],
  pages: [],
  queryId: '',
  queryResult: [],
  statuses: [],
  err: null,
  filter: {
    campaignId: null,
    accountId: null,
    agId: null,
  }
};

const defaultState = new Immutable.Map(options);

export default function(state = defaultState, action) {
  switch (action.type) {

    case 'GET_CUSTOMERS':
    case 'GET_KEYWORDS':
    case 'GET_CAMPAIGNS':
    case 'GET_LANDING_PAGES':
    case 'LOAD_TRANSLATIONS':
    case 'QUERY_ID':
    case 'GET_STATUSES':
    case 'GET_CYCLE':
      return state.set('loading', true);

    case 'GET_CUSTOMERS_SUCCESS':
      const customers = action.res.data;

      return state.set('loading', false)
        .set('loaded', true)
        .set('customers', customers)
        .set('campaigns', {});

    case 'GET_CAMPAIGNS_SUCCESS': {
      const data = action.res.data;
      let indexedCampaigns = {};
      let groupedCampaigns = {};
      let groupedAdGroups = {};
      let namedCampaigns = {};

      if (data && data.campaigns) {
        // grouping the campaigns_settings by accountId and campaign
        groupedCampaigns = data.campaigns.reduce((prev, item) => {
          if (!prev[item.Account]) {
            prev[item.Account] = {};
            prev[item.Account][item.intCampaign] = [item];
          } else if (!prev[item.Account][item.intCampaign]) {
            prev[item.Account][item.intCampaign] = [item];
          } else {
            prev[item.Account][item.intCampaign].push(item);
          }

          // add to indexed campaigns list
          indexedCampaigns[item.intCampaign] = item;
          namedCampaigns[item.Campaign] = item;

          return prev;
        }, {});
      }

      if (data && data.adgroups) {
        groupedAdGroups = data.adgroups.reduce((prev, item) => {
          prev[item.intAG] = item;
          return prev;
        }, {});
      }
      localStorage.setItem('mcId', action.mcId);
      return state.set('loading', false)
        .set('loaded', true)
        .set('indexedCampaigns', indexedCampaigns)
        .set('groupedCampaigns', groupedCampaigns)
        .set('namedCampaigns', namedCampaigns)
        .set('groupedAdGroups', groupedAdGroups)
        .set('mcId', action.mcId)
        .set('campaigns', data)
        .set('selectedMenu', 'adgroups');
    }

    case 'GET_KEYWORDS_SUCCESS':
      const keywords = action.res.data;

      return state.set('loading', false)
        .set('loaded', true)
        .set('keywords', keywords);

    case 'GET_LANDING_PAGES_SUCCESS':
      const pages = action.res.data;

      return state.set('loading', false)
        .set('loaded', true)
        .set('pages', pages);

    case 'LOAD_TRANSLATIONS_SUCCESS': {
      const languages = state.get('languages');
      const data = action.res.data;
      const translations = data.reduce((prev, item) => {
        const lang = languages[item.language];

        const msgId = item.msgid;
        const msgId2 = msgId + 's';

        if (lang) {
          if (!prev[item.language]) {
            prev[item.language] = {};
          }
          prev[item.language][msgId.toUpperCase()] = item.translation;
          prev[item.language][msgId2.toUpperCase()] = item.translation;
        }

        prev['English'][item.msgid] = item.msgid;
        return prev;
      }, {'English': {}});

      return state.set('loading', false)
        .set('loaded', true)
        .set('translations', translations);
    }

    case 'QUERY_ID_SUCCESS':
      const queryResult = action.res.data;

      return state.set('loading', false)
        .set('loaded', true)
        .set('queryResult', queryResult)
        .set('queryId', action.queryId);

    case 'GET_STATUSES_SUCCESS':
      const statuses = action.res.data;

      return state.set('loading', false)
        .set('statuses', statuses);

      case 'GET_CYCLE_SUCCESS':
        const cycle = action.res.data;
        console.log(cycle);
        return state.set('loading', false)
          .set('loaded', true)
          .set('cycle', cycle);

    case 'GET_CUSTOMERS_FAILURE':
    case 'GET_CAMPAIGNS_FAILURE':
    case 'GET_KEYWORDS_FAILURE':
    case 'GET_LANDING_PAGES_FAILURE':
    case 'GET_STATUSES_FAILURE':
    case 'LOAD_TRANSLATIONS_FAILURE':
    case 'QUERY_ID_FAILURE':
      return state.set('loading', false)
        .set('err', action.err);

    case 'SELECT_MENU':
      return state.set('selectedMenu', action.menu);

    case 'SELECT_LOCALE':
      return state.set('selectedLocale', action.locale);

    case 'SET_TRANSLATIONS':
      return state.set('translations', action.translations);

    case 'CLEAR_MCID':
      localStorage.removeItem('mcId');
      return state.set('mcId', '');

    case 'SET_SPIN':
      return state.set('spin', action.spin);

    case 'SET_FILTER':
      return state.set('filter', Object.assign({}, state.filter, action.filter));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ReportsReducer.js